<!-- <div id="global-loader" style="display: none">
  <div class="page-loader"></div>
</div> -->

<!-- <div class="custom-loader-wrapper">
  <div class="custom-loader"></div>
  <p>Loading...</p>
</div> -->

<!-- <div class="spinner-border" role="status" style="color: #f26522">
            <span class="visually-hidden">Loading...</span>
          </div> -->
<div class="attendance-image-loader" role="status">
  <img src="assets/img/logo-small.webp" alt="Loading..." />
  <span class="visually-hidden">Loading...</span>
</div>
